<template>
       <span class='pulse-button' @click="showHomeScreen(true)" v-bind:style="borderStyle">
           <i class="fas fa-caret-left"></i>       
        </span>       
</template>

<script>
    /* eslint-disable */
    import { mapState, mapActions } from 'vuex'

    export default {
        name: "add-homescreen-button",
        computed: {
            ...mapState({               
                customization: state => state.common.customization,
                industryId: state => state.common.industryId,
            }),
             borderStyle: function () {
                var borderStyle = 'solid 3px ' + this.customization.mainColor;
                var backgroundStyle =  this.customization.mainColor;
                var colorStyle = this.customization.mainColor
                var boxshadowStyle = '0 0 0 0 '+this.customization.mainColor
                return {
                    border: borderStyle,
                   // background: backgroundStyle,
                    color: colorStyle,
                    'box-shadow':boxshadowStyle,
                    '-webkit-box-shadow': boxshadowStyle,  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
                    '-moz-box-shadow':    boxshadowStyle
                }
            },            
        },
        methods:{
            ...mapActions({
               showHomeScreen: "standalone/showAddHomeScreen"         
            }),
             getRgbaWithOpacity(hex){
                if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                    var c;
                    c= hex.substring(1).split('');
                    if(c.length== 3){
                        c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c= '0x'+c.join('');
                    return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.2)';
                }
            else
                return "rgba(255, 242, 0, 0.2)";  
            },
            getRgbaFromHex(hex){
                if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                    var c;
                    c= hex.substring(1).split('');
                    if(c.length== 3){
                        c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c= '0x'+c.join('');
                    return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',1)';
                }
            else
                return "rgba(255, 242, 0, 1)";  
            },                                    
        },
        data() {
            return {

            }
        }
    }  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// add-homescreen-button.vue?c8420aac